import {PHOTO_DECORATIONS} from './photo-catalog.js';
import {layerScalePatch} from './layer-edit.js';

// Match the photographic fallbacks used by the renderer for older saved designs.
const LEGACY_PHOTOS={pearl:'ref-pearl-white',diamond:'ref-diamond-tiny',gem:'ref-diamond-shape-03',teardrop:'ref-diamond-shape-04',bow:'ref-bow-satin-01','silver-bow':'ref-bow-satin-02',ribbon:'ref-bow-satin-05',butterfly:'ref-pearl-shell-08',heart:'ref-glass-pink-01','heart-gem':'ref-diamond-shape-05',shell:'ref-pearl-shell-05',feather:'ref-metal-charm-14',cross:'ref-metal-cross-b-04'};

export function layerLocalBounds(layer) {
  const photo=layer.kind==='charm'&&PHOTO_DECORATIONS.find(item=>item.id===(LEGACY_PHOTOS[layer.type]||layer.type));
  if(photo){const box=photo.presentationBounds||photo.visibleBounds||photo,aspect=box.width/box.height,longest=photo.defaultSize*5;
    const width=aspect>=1?longest:longest*aspect,height=aspect>=1?longest/aspect:longest;return{x:-width/2,y:-height/2,width,height};}
  if(layer.kind==='stroke'&&layer.points?.length){const pad=(layer.strokeWidth||2)/2,x=Math.min(...layer.points.map(p=>p.x))-50-pad,y=Math.min(...layer.points.map(p=>p.y))-75-pad;
    return{x,y,width:Math.max(...layer.points.map(p=>p.x))-50+pad-x,height:Math.max(...layer.points.map(p=>p.y))-75+pad-y};}
  if(layer.kind==='pattern')return{x:-50,y:-75,width:100,height:150};
  const size=layer.kind==='sticker'?44:40;return{x:-size/2,y:-size/2,width:size,height:size};
}
export function layerPoint(layer,point) {
  const angle=(layer.rotation||0)*Math.PI/180,scale=layer.scale||1;
  return{x:layer.x+scale*(point.x*Math.cos(angle)-point.y*Math.sin(angle)),y:layer.y+scale*(point.x*Math.sin(angle)+point.y*Math.cos(angle))};
}
export function normalizeRotation(degrees) {
  if(!Number.isFinite(degrees))return 0;
  return ((degrees+180)%360+360)%360-180;
}
// Work in the nail's SVG coordinates, so a zoomed or tilted canvas does not
// change the gesture. Starting from the saved angle also avoids grip jumps.
export function rotationFromCenter(layer,start,point) {
  const rotation=normalizeRotation(layer.rotation||0);
  if(!start||!point||![layer.x,layer.y,start.x,start.y,point.x,point.y].every(Number.isFinite))return{rotation};
  const sx=start.x-layer.x,sy=start.y-layer.y,dx=point.x-layer.x,dy=point.y-layer.y;
  if(Math.hypot(sx,sy)<.001||Math.hypot(dx,dy)<.001)return{rotation};
  return{rotation:normalizeRotation(rotation+(Math.atan2(dy,dx)-Math.atan2(sy,sx))*180/Math.PI)};
}
export function containsLayerPoint(layer,point) {
  const angle=-(layer.rotation||0)*Math.PI/180,dx=point.x-layer.x,dy=point.y-layer.y,scale=layer.scale||1,b=layerLocalBounds(layer);
  const x=(dx*Math.cos(angle)-dy*Math.sin(angle))/scale,y=(dx*Math.sin(angle)+dy*Math.cos(angle))/scale;
  return x>=b.x&&x<=b.x+b.width&&y>=b.y&&y<=b.y+b.height;
}
// An SVG pattern paints a full rectangle, including its transparent gaps.
// Pick visible bounded decorations through that rectangle before the background.
export function pickLayer(layers,point,hitId,selectedId) {
  const visible=layers.filter(l=>l.visible!==false),hit=visible.find(l=>l.id===hitId);
  if(!hit||hit.kind==='pattern'){
    const decoration=[...visible].reverse().find(l=>['charm','sticker'].includes(l.kind)&&containsLayerPoint(l,point));
    if(decoration)return decoration;
    const selected=visible.find(l=>l.id===selectedId&&l.kind==='pattern');if(selected)return selected;
  }
  return hit;
}
export function resizeFromCorner(layer,corner,start,point) {
  if(layer.kind==='pattern'){
    const dx=start.x-50,dy=start.y-75,ratio=((point.x-50)*dx+(point.y-75)*dy)/(dx*dx+dy*dy||1);
    return layerScalePatch(layer,layer.scale*ratio);
  }
  const b=layerLocalBounds(layer),opposite={x:corner.includes('e')?b.x:b.x+b.width,y:corner.includes('s')?b.y:b.y+b.height};
  const anchor=layerPoint(layer,opposite),dx=start.x-anchor.x,dy=start.y-anchor.y;
  const ratio=((point.x-anchor.x)*dx+(point.y-anchor.y)*dy)/(dx*dx+dy*dy||1),patch=layerScalePatch(layer,layer.scale*ratio);
  const newAnchor=layerPoint({...layer,...patch},opposite);
  return{...patch,x:Math.max(-60,Math.min(160,layer.x+anchor.x-newAnchor.x)),y:Math.max(-60,Math.min(210,layer.y+anchor.y-newAnchor.y))};
}
